var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._t("header",function(){return [_vm._t("header-action")]}),_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }